module.exports = __webpack_public_path__ + "img/KK0041C-BL.14a9992f.jpg";